var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useMemo } from "react";
import { Controller } from "react-hook-form";
import useService from "../../Hooks/useService";
import PersonService from "../../../Services/Person.service";
import StringUtils from "../../../../util/stringUtils";
import TranscriptCourseAttendanceStatusService from "../../../Domain/TranscriptCourseAttendanceStatus/TranscriptCourseAttendanceStatus.service";
import { ModalFormFormat } from "../../UI/FormFormat/FormFormat";
import ServiceResult from "../../UI/ServiceResult/ServiceResult";
import AttendanceService from "../../../Services/Attendance.service";
import DeprecatedSelect from "../../UI/DeprecatedSelect/DeprecatedSelect";
import useUniqueId from "../../Hooks/useUniqueId";
import TranscriptCourseDomainService from "../../../Domain/TranscriptCourse/TranscriptCourseDomainService";
import { AlertWarning } from "../../UI/StandardAlerts/StandardAlerts";
import ListService from "../../../Services/Shared/List.service";
const MarkAsModal = (_a) => {
    var { studentAffiliationIds, transcriptCourses, meetingId, onMarked, isNeverOrStoppedAttendingEnabled } = _a, modalProps = __rest(_a, ["studentAffiliationIds", "transcriptCourses", "meetingId", "onMarked", "isNeverOrStoppedAttendingEnabled"]);
    const [studentsState, loadStudents] = useService(PersonService.peopleFromAffiliationIds);
    const transcriptCourseIds = transcriptCourses.map((tc) => tc.transcriptCourseId);
    const inEligibleStudents = useMemo(() => {
        return transcriptCourses.filter((tc) => !TranscriptCourseDomainService.isStudentEligibleToBeMarked(tc));
    }, [transcriptCourses]);
    const inEligibleTranscriptCourseIds = inEligibleStudents.map((s) => s.transcriptCourseId);
    React.useEffect(() => {
        if (modalProps.isOpen) {
            loadStudents(studentAffiliationIds);
        }
    }, [loadStudents, modalProps.isOpen, studentAffiliationIds]);
    const makeId = useUniqueId()[1];
    return (_jsx(ModalFormFormat, Object.assign({}, modalProps, { defaultValue: {
            attendanceStatus: TranscriptCourseAttendanceStatusService.PresentId,
        }, modalTitle: "Mark Students As", handleSubmit: ({ attendanceStatus }) => __awaiter(void 0, void 0, void 0, function* () {
            const eligibleTranscriptCourseIds = transcriptCourseIds.filter((tci) => !inEligibleTranscriptCourseIds.includes(tci));
            if (eligibleTranscriptCourseIds.length) {
                return AttendanceService.setAttendanceStatus(eligibleTranscriptCourseIds, meetingId, attendanceStatus);
            }
            return [];
        }), onSuccess: onMarked, children: (formProps) => (_jsx(_Fragment, { children: _jsx(ServiceResult, { state: studentsState, children: (students) => (_jsxs("div", { children: [inEligibleStudents.length > 0 && (_jsx(AlertWarning, { message: _jsxs("div", { children: ["The following students are not eligible to have their status changed:", _jsx("div", { children: ListService.displayWithCommasAndAnd(inEligibleStudents.map((s) => { var _a; return (_a = s.student) === null || _a === void 0 ? void 0 : _a.fullName; })) })] }) })), _jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: makeId("students"), children: "Students" }), _jsx("div", { id: makeId("students"), children: StringUtils.joinWithCommaAndAnd(students.map((student) => student.fullName)) })] }), _jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: makeId("attendanceStatus"), children: "Attendance Status" }), _jsx(Controller, { id: makeId("attendanceStatus"), name: "attendanceStatus", control: formProps.control, onChange: (change) => {
                                        return change && change[0].value;
                                    }, as: _jsx(DeprecatedSelect, { "aria-label": "Attendance Status", options: [
                                            {
                                                label: "Present",
                                                value: TranscriptCourseAttendanceStatusService.PresentId,
                                            },
                                            {
                                                label: "Tardy",
                                                value: TranscriptCourseAttendanceStatusService.TardyId,
                                            },
                                            {
                                                label: "Absent",
                                                value: TranscriptCourseAttendanceStatusService.AbsentId,
                                            },
                                        ], clearable: false }) })] })] })) }) })) })));
};
export default MarkAsModal;
